import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useLock } from '../../store/lock';
import { ReauthGate } from './ReauthGate';

/**
 * Gates the whole app behind a PIN/biometric unlock on launch. ReauthGate itself
 * no-ops (auto-passes) when the user has neither a PIN nor biometric enabled, so
 * this is transparent for users without security set up. Unlocking here does NOT
 * grant a send/seed reauth token — those prompt again at action time.
 */
export function AppLock({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  const unlocked = useLock((s) => s.unlocked);
  const unlock = useLock((s) => s.unlock);

  if (unlocked) return <>{children}</>;

  return (
    <ReauthGate
      onAuthed={async () => {
        unlock();
        return true;
      }}
      bioTitle={t('security.unlockTitle')}
      bioHint={t('security.unlockHint')}
    />
  );
}
